import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ConfirmPopup, ConfirmPopupStyle } from 'primeng/confirmpopup';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { MotionModule } from 'primeng/motion';

@Component({
  selector: 'app-confirm-popup',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.scss'],
  imports: [
    CommonModule,
    ButtonModule,
    MotionModule,
  ],
  encapsulation: ViewEncapsulation.None,
  providers: [ConfirmPopupStyle],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    class: 'p-element'
  }
})
export class ConfirmPopupComponent extends ConfirmPopup {
}
